import { useMemo } from 'react';
import { useDataService } from './ApiDataService';

export function EnvironmentServiceFactory(dataService) {
    function getEnvironment() {
        return Promise.all([
            dataService.get(`/ipm/v1/config/environment`),
            dataService.get('/api/v3/version'),
            dataService.get('/ipm/public/systemconfiguration/getPasswordRule'),
        ]).then(([envResponse, verResponse, passwordRules]) => ({
            ...envResponse?.environment,
            version: verResponse?.version || 'Unknown',
            serverName: verResponse?.name || 'Unknown',
            passwordRules,
        }));
    }

    return {
        getEnvironment,
    };
}

export function useEnvironmentService() {
    const dataService = useDataService();
    return useMemo(() => EnvironmentServiceFactory(dataService), [dataService]);
}
